import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import AcService from '../../components/services/ac'

const AC = () => {

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Helmet>
<title>Air Conditioning Contractor in India | Unique Engineers</title>
<meta name="description" content="Choose Unique Engineers as your air conditioning contractor in India for professional HVAC solutions, seamless project execution and superior indoor comfort." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/air-conditioning-contractor-in-india/" />
            </Helmet>
             <Banner img={'/assets/images/electrical-banner.jpg'} title= 'React out and Connect' />
            <AcService />
        </Grid>
    )

}

export default AC;